import { render, staticRenderFns } from "./AddDealTaxAndChargesForm.vue?vue&type=template&id=5f44a818&scoped=true&"
import script from "./AddDealTaxAndChargesForm.vue?vue&type=script&lang=js&"
export * from "./AddDealTaxAndChargesForm.vue?vue&type=script&lang=js&"
import style0 from "./AddDealTaxAndChargesForm.vue?vue&type=style&index=0&id=5f44a818&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f44a818",
  null
  
)

export default component.exports